import { useCallback } from "react";

import { PartialSubmitOptions } from "./usePartialSubmit";

type NoSubmitOptions = Pick<
  PartialSubmitOptions,
  "onNext" | "validate" | "onInvalid" | "disableNextIfInvalid"
>;

// this provides referential stability to these defaults
const defaultOnInvalid = () => {};
const defaultValidate = () => true;

/**
 * Helper hook for handling progressing to the next page without submitting
 */
const useNoSubmit = ({
  onNext,
  validate = defaultValidate,
  onInvalid = defaultOnInvalid,
  disableNextIfInvalid = true,
}: NoSubmitOptions) => {
  const handleNext = useCallback(
    (event?: React.ChangeEvent<HTMLFormElement>) => {
      if (event?.preventDefault) {
        event.preventDefault();
      }

      if (validate()) {
        onNext();
      } else {
        onInvalid(onNext);
      }
    },
    [onNext, validate, onInvalid]
  );
  const submitHandler = useCallback(async () => handleNext(), [handleNext]);

  const nextDisabled = disableNextIfInvalid && !validate();
  return { handleNext, submitHandler, nextDisabled };
};

export default useNoSubmit;
